import { Flex, Text } from "@capioweb/ui-components"
import React from "react"
import { InterestsFieldset } from "./Fieldset"
import { SharedFormProps } from "../../../../@types/CapioWeb/core"

export const ManageInterests: React.FC<SharedFormProps> = (props) => {
	return (
		<Flex flexDirection="column">
			{props.fields.map((field, i) => {
				return (
					<Flex flexDirection={"column"} key={i}>
						<Text variant={"headline-4"} pt={i === 0 ? 0 : 3} mb={1.5}>
							{field.label}
						</Text>
						{field.items && (
							<Flex
								flexDirection={"row"}
								borderBottom={i !== props.fields.length - 1 ? true : false}
								pb={3}
							>
								<InterestsFieldset items={field.items} />
							</Flex>
						)}
					</Flex>
				)
			})}
		</Flex>
	)
}
